import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Select, Table } from "antd";
import { tab } from "@testing-library/user-event/dist/tab";

const data = {
	"call 1": [
		{ name: "attr 1", value: 50 },
		{ name: "attr 2", value: 60 },
		{ name: "attr 3", value: 55 },
		{ name: "attr 4", value: 75 },
		{ name: "attr 5", value: 90 },
		{ name: "attr 6", value: 85 },
	],
	"call 2": [
		{ name: "attr 1", value: 40 },
		{ name: "attr 2", value: 60 },
		{ name: "attr 3", value: 33 },
		{ name: "attr 4", value: 78 },
		{ name: "attr 5", value: 82 },
		{ name: "attr 6", value: 92 },
	],
	"call 3": [
		{ name: "attr 1", value: 94 },
		{ name: "attr 2", value: 82 },
		{ name: "attr 3", value: 87 },
		{ name: "attr 4", value: 84 },
		{ name: "attr 5", value: 78 },
		{ name: "attr 6", value: 82 },
	],
	"call 4": [
		{ name: "attr 1", value: 72 },
		{ name: "attr 2", value: 78 },
		{ name: "attr 3", value: 74 },
		{ name: "attr 4", value: 79 },
		{ name: "attr 5", value: 82 },
		{ name: "attr 6", value: 84 },
	],
	"call 5": [
		{ name: "attr 1", value: 62 },
		{ name: "attr 2", value: 67 },
		{ name: "attr 3", value: 76 },
		{ name: "attr 4", value: 71 },
		{ name: "attr 5", value: 81 },
		{ name: "attr 6", value: 89 },
	],
	"call 6": [
		{ name: "attr 1", value: 76 },
		{ name: "attr 2", value: 91 },
		{ name: "attr 3", value: 54 },
		{ name: "attr 4", value: 65 },
		{ name: "attr 5", value: 72 },
		{ name: "attr 6", value: 86 },
	],
};

const BranchWiseAttrLines = () => {
	const [selectDropdown, setSelectedDropdown] = useState([]);
	const [graphData, setGraphData] = useState({ series: [], categories: [] });

	const optionss = [];
	Object.keys(data).forEach((elem) => {
		optionss.push({
			label: elem,
			value: elem,
		});
	});

	useEffect(() => {
		let graphData = { series: [], categories: [] };
		for (let branch in data) {
			if (!selectDropdown.length || selectDropdown.includes(branch)) {
				let branchdata = data[branch];
				let lineData = [];
				for (let elem of branchdata) {
					let { name, value } = elem;
					if (!graphData.categories.includes(name)) graphData.categories.push(name);
					lineData.push(value);
				}
				graphData.series.push({ name: branch, data: lineData });
			}
		}

		setGraphData({ ...graphData });
	}, [selectDropdown]);

	let { series, categories } = graphData;
	if (!series.length) return <></>;
	const option = {
		options: {
			chart: {
				height: 180,
				type: "line",
				zoom: {
					enabled: false,
				},
				toolbar: {
					show: false,
				},
			},
			colors: [
				"#e34132",
				"#fd823e",
				"#ffaf12",
				"#b49c73",
				"#f0daa4",
				"#565d47",
				"#4ec5a5",
				"#117893",
				"#34558b",
				"#798fa8",
				"#72617d",
				"#a2553a",
				"#eaac9d",
				"#3b3d4b",
				"#a09d9c",
				"#eff0f1",
			],
			dataLabels: {
				enabled: false,
			},

			xaxis: {
				categories,
			},
			yaxis: { show: false },
			legend: { show: false },
			grid: {
				show: false,
				padding: {
					left: 20, // Add padding to the left side
					right: 0,
					top: 0,
					bottom: 0,
				},
			},
			stroke: { width: 1 },
			markers: { size: 4 },
		},
	};

	const { options } = option;

	const tableData = [];
	let index = 0;
	for (let branch in data) {
		let obj = {};
		for (let month of ["Jan'24", "Feb'24", "Mar'24", "Apr'24", "May'24", "Jun'24", "Jul'24"]) {
			obj[month] = `${Math.floor(Math.random() * (100 - 70) + 70)}%`;
		}
		tableData.push({
			key: index.toString(),
			name: branch,

			...obj,
		});
		++index;
	}
	const expandedRowRender = () => {
		const tableData = [];
		let index = 0;
		for (let branch in data) {
			let obj = {};
			for (let month of ["Jan'24", "Feb'24", "Mar'24", "Apr'24", "May'24", "Jun'24", "Jul'24"]) {
				obj[month] = `${Math.floor(Math.random() * (100 - 70) + 70)}%`;
			}
			tableData.push({
				key: index.toString(),
				name: "attr " + index,

				...obj,
			});
			++index;
		}
		return (
			<Table
				columns={[
					{
						title: "",
						dataIndex: "name",
						key: "name",
						align: "center",
					},

					...["Jan'24", "Feb'24", "Mar'24", "Apr'24", "May'24", "Jun'24", "Jul'24"].map((month) => {
						return {
							title: month,
							dataIndex: month,
							key: month,
							align: "center",
						};
					}),
				]}
				dataSource={tableData}
				pagination={false}
			/>
		);
	};
	return (
		<>
			<div className="d-flex justify-content-between">
				<div style={{ fontWeight: "bold" }}>Attribute Score – July’24</div>
				<div className="ml-auto w-50 px-2">
					<Select
						mode="multiple"
						style={{
							width: "100%",
						}}
						placeholder="Select Call Centers"
						onChange={(value) => {
							setSelectedDropdown(value);
						}}
						options={optionss}
						maxTagCount={"responsive"}
						defaultValue={selectDropdown}
					/>
				</div>
			</div>
			<div className="p-1">
				<Chart options={options} series={series} type={"line"} height={180} />
			</div>
			<div>
				<div style={{ fontWeight: "bold" }}>Call Center & Attributes</div>
				<Table
					columns={[
						{
							title: "",
							dataIndex: "name",
							key: "name",
							align: "center",
						},

						...["Jan'24", "Feb'24", "Mar'24", "Apr'24", "May'24", "Jun'24", "Jul'24"].map((month) => {
							return {
								title: month,
								dataIndex: month,
								key: month,
								align: "center",
							};
						}),
					]}
					expandable={{
						expandedRowRender,
					}}
					dataSource={tableData}
					size="small"
					pagination={false}
					scroll={{
						x: 700, // Set a horizontal scroll
						y: 175, // Set a vertical scroll
					}}
				/>
			</div>
		</>
	);
};

export default BranchWiseAttrLines;
